<template>
  <div>
   <div class="spinner-border"  style="width: 3rem; height: 3rem;" role="status">
</div>
  </div>
</template>

<script>
export default {
  name: 'CopiasSpinnerCarga',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>


<style scoped>

</style>